import { ConditionDTO, PropertyConditionDTO } from '@invenco/common-interface/automation';

import { isPropertyCondition } from '../../helpers/conditions';
import { FormKey } from '../../helpers/forms';
import { AddButton } from '../AddButton';
import { ChildSection } from '../styles';
import { ConditionList } from './ConditionList';
import { PropertyConditionInput } from './PropertyConditionInput';

export type ConditionProps = {
  level: number;
  editable: boolean;
  condition: ConditionDTO | PropertyConditionDTO;
  formKey: FormKey;
  onAddCondition: (formKey: FormKey) => void;
  onDeleteCondition: (formKey: FormKey) => void;
  onResetPropertyCondition: (formKey: FormKey) => void;
};

export function Condition({
  level,
  editable,
  condition,
  formKey,
  onAddCondition,
  onDeleteCondition,
  onResetPropertyCondition,
}: ConditionProps) {
  if (isPropertyCondition(condition)) {
    return (
      <PropertyConditionInput
        formKey={formKey}
        onDelete={() => onDeleteCondition(formKey)}
        onChangeType={() => onResetPropertyCondition(formKey)}
        editable={editable}
      />
    );
  }

  if (condition.childConditions) {
    return (
      <ChildSection $alternate={level % 2 === 0}>
        <ConditionList
          level={level}
          editable={editable}
          condition={condition}
          formKey={formKey}
          onAddCondition={onAddCondition}
          onDeleteCondition={onDeleteCondition}
          onResetPropertyCondition={onResetPropertyCondition}
        />
        {editable && condition.childConditionType && (
          <AddButton
            conditionType={condition.childConditionType}
            onClick={() => onAddCondition(formKey)}
          />
        )}
      </ChildSection>
    );
  }

  return null;
}
